var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.28 41.886l-.003-24.448L57.62 29.704 34.28 41.886zM85.536 13.2s-.845-5.996-3.434-8.636C78.816 1.1 75.133 1.082 73.445.88 61.355 0 43.22 0 43.22 0h-.038S25.045 0 12.955.88c-1.7.2-5.37.218-8.66 3.684C1.706 7.206.864 13.2.864 13.2S0 20.244 0 27.284v6.602C0 40.93.864 47.97.864 47.97s.842 5.996 3.432 8.636c3.29 3.467 7.606 3.358 9.528 3.72 6.912.67 29.376.876 29.376.876s18.155-.027 30.245-.908c1.688-.204 5.37-.22 8.656-3.687 2.59-2.64 3.434-8.636 3.434-8.636s.864-7.04.864-14.082v-6.602c0-7.04-.864-14.082-.864-14.082h0z","transform":"matrix(.992546 -.121869 .121869 .992546 -1.774761 8.480763)","fill":"#5e5e5e","fillRule":"evenodd"}));
}

Youtube.defaultProps = {"width":"89","height":"67"};

module.exports = Youtube;

Youtube.default = Youtube;
